<template>
    <div class="left">
        <div class="left_left">
            <v-header @addFn="addFn" :Content="headerContent" @leftRefreshFn="leftRefreshFn" />

            <!-- 菜单 -->

            <v-menu @chidrenDio="chidrenDio" ref="vMenu" />
        </div>

        <!-- <div class="moveIcon"></div> -->

        <Modal :title="$t(title)" :visible.sync="isShow" width="600px">
            <v-form
                :isChildren="isChildren"
                v-bind="$attrs"
                :clickMenu="clickMenu"
                ref="vForm"
                :title="$t(title)"
                :handleStatus="handleStatus"
                :treeChooze="treeChooze"
                :shareParamArray="shareParamArray"
            />

            <div slot="footer">
                <el-button type="primary" @click="isShow = false">{{ $t('public.btn_close') }}</el-button>
                <el-button type="primary" @click="handleSave">{{ $t('public.btn_ok') }}</el-button>
            </div>
        </Modal>
    </div>
</template>

<script>
import getPublic from '@/utils/getPublic.js';

import HeaderVue from './Header.vue';
import DiaFormVue from './DiaForm.vue';
import MenuTreeVue from './MenuTree.vue';
import { pageOperateAdd, pageOperateUpdate } from '@/api/modules/resoure';
import { userLogout } from '@/api/modules/indexPage.js';

export default {
    mixins: [getPublic],
    components: {
        'v-header': HeaderVue,
        'v-form': DiaFormVue,
        'v-menu': MenuTreeVue
    },
    data() {
        return {
            headerContent: {
                text: 'resource.menu',
                iconArray: [
                    {
                        id: 1,
                        title: 'resource.add',
                        icon: 'el-icon-plus',
                        method: 'addFn'
                    },
                    {
                        id: 2,
                        title: 'resource.refresh',
                        icon: 'el-icon-refresh',
                        method: 'leftRefreshFn'
                    }
                ]
            },
            title: 'buttonTitle.Add',
            handleStatus: '',
            isShow: false,
            /** 选中的菜单数据 */
            treeChooze: {},
            isChildren: false,
            clickMenu: null
        };
    },
    methods: {
        addFn() {
            this.isShow = true;
            this.title = 'public.btn_add';
            this.handleStatus = 'Add';
            // 获取公共类
            this.getPublicFn();
            this.$nextTick(() => {
                this.$refs.vForm.clearValidate();
            });
        },
        getPublicFn() {
            this.shareParamFn('menu_level', '0').then(({ result }) => {
                this.shareParamArray = result;
            });
        },
        async handleSave() {
            const childrenForm = this.$refs.vForm;
            const flag = await childrenForm.justify();
            if (!flag) return;

            /** 数据整理判断 */
            const query = this.saveData();
            let httpUrl = '',
                msg = '';
            if (this.handleStatus === 'Add') {
                httpUrl = pageOperateAdd;
                msg = 'public.tip_add_succ';
                delete query.id;
            } else {
                httpUrl = pageOperateUpdate;
                query.id = this.$refs.vForm.dioForm.id;
                msg = 'public.tip_modify_succ';
            }
            httpUrl(query).then(({ result, state }) => {
                if (result === 200) {
                    this.isShow = false;
                    this.$message.success(this.$t(msg));
                    this.$refs.vMenu.initTree();
                    // 系统导航菜单在登录时缓存到 Vuex，需重新登录才会刷新
                    this.$confirm(this.$t('public.relogin_tip'), this.$t('public.prompt'), {
                        confirmButtonText: this.$t('public.btn_yes'),
                        cancelButtonText: this.$t('public.btn_cancel'),
                        type: 'warning'
                    }).then(() => {
                        userLogout().then(() => {
                            this.$router.push('/login');
                        });
                    }).catch(() => {});
                } else if (result === 407) {
                    this.$message.error('resource.code_407');
                } else if (result === 408) {
                    this.$message.error('resource.code_408');
                } else {
                    this.$message.error(state.msg);
                }
            });
        },

        saveData() {
            const childrenForm = this.$refs.vForm;
            let param = {};
            let { code, parentId, parentCode, name, nameZh, nameEn, enable, view, icon, type, url } = childrenForm.dioForm;
            // 判断是否是一级菜单 & 同级菜单
            if (!this.isChildren && type === 1) {
                parentId = '';
                parentCode = '';
            } else if (!this.isChildren && type === 2) {
                parentId = this.treeChooze.id;
                parentCode = this.treeChooze.code;
            } else if (this.isChildren && type === 1) {
                parentId = this.treeChooze.parentId;
                parentCode = this.treeChooze.parentCode;
            } else {
            }
            param = {
                code,
                parentId,
                parentCode,
                name,
                nameZh,
                nameEn,
                url,
                enable,
                view,
                icon
            };
            return param;
        },
        leftRefreshFn() {
            this.$refs.vMenu.initTree();
        },
        chidrenDio(row) {
            this.treeChooze = { ...row };
            this.clickMenu = row.name;
            // 如果选中了二级菜单  那么没有子级菜单的选项
            if (row.parentCode) {
                this.isChildren = true;
            } else {
                this.isChildren = false;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.left {
    height: 100%;
    width: 100%;
    display: flex;
    border-right: 1px solid #ccc;
}

.left_left {
    width: 300px;
    height: 100%;
    // border-right: 1px solid #ccc;
    box-sizing: border-box;
}

.moveIcon {
    height: 100%;
    width: 15px;
    // background-color: aquamarine;
}
</style>
